import { createContext, useContext, useEffect, useMemo, useState } from "react";

const KEY = "bbcr_basket";
const BasketContext = createContext(null);

function load() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

export const BasketProvider = ({ children }) => {
  const [items, setItems] = useState(load);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (item) =>
      setItems((prev) => {
        const idx = prev.findIndex(
          (p) => p.product_id === item.product_id && p.variant_id === item.variant_id
        );
        if (idx >= 0) {
          const next = [...prev];
          next[idx] = { ...next[idx], qty: next[idx].qty + item.qty };
          return next;
        }
        return [...prev, item];
      });
    const remove = (index) => setItems((prev) => prev.filter((_, i) => i !== index));
    const setQty = (index, qty) =>
      setItems((prev) =>
        qty <= 0
          ? prev.filter((_, i) => i !== index)
          : prev.map((p, i) => (i === index ? { ...p, qty } : p))
      );
    const clear = () => setItems([]);
    const count = items.reduce((n, i) => n + i.qty, 0);
    const subtotalPence = items.reduce((n, i) => n + i.qty * i.unit_price_pence, 0);
    return { items, add, remove, setQty, clear, count, subtotalPence };
  }, [items]);

  return <BasketContext.Provider value={value}>{children}</BasketContext.Provider>;
};

export const useBasket = () => useContext(BasketContext);
